import MojitoCore from 'mojito/core';

export default class EventDisclaimer extends MojitoCore.Presentation.UIViewImplementation {
    render() {
        return null;
    }
}
